import React from "react"
import styled from "~ui/styled"
import { observer } from "mobx-react-lite"
import { useTheme } from "~ui/styled"
import { useStores } from "~models"
import { CenterFlex, IconButton, Text } from "~components/El"
import HomeHeader from "~components/home-header"
import { Dropdown, LogoHeader } from "~components/chat-list/dropdown"
import useNavigation from "~hooks/useNavigation"
import { useNavigate } from "react-router-dom"
import { globalToast } from "~utils"
import { getNoticeReturnPath, type PcTabPath } from "~ui/app-shell"
import { useNoticeCenter } from "~pages/app-stack/notice-center/notice-center-context"

const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  min-height: 52px;
  height: 52px;
  overflow: visible;
  padding: 0 12px;
  background: ${({ theme }) => theme.colors.blockBackground};
`

const Title = styled(CenterFlex)`
  flex: 1;
  text-align: center;
  font-size: 15px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text};
`

const TAB_META: Record<
  string,
  { title?: string; showHomeHeader?: boolean }
> = {
  "/chats": { showHomeHeader: true },
  "/contacts": { title: "好友" },
  "/groups": { showHomeHeader: true },
  "/me": { title: "我的" },
}

const MarkAllReadButton = observer(function MarkAllReadButton() {
  const { apiStore, notificationStore } = useStores()
  const { replaceList } = useNoticeCenter()

  return (
    <Text
      color="primary"
      fontSize="14px"
      fontWeight="600"
      style={{ cursor: "pointer" }}
      onClick={async () => {
        try {
          const { read, list } = await apiStore.markAllNotificationsAsReadAndRefreshList(
            {},
            { page: 1, limit: 20 },
          )
          if (!read) return
          notificationStore.refreshUserUnreadNotificationCount()
          const result = Array.isArray(list?.data) ? list.data : []
          replaceList(result)
        } catch (err: any) {
          globalToast.show(err?.message || "操作失败")
        }
      }}
    >
      全部已读
    </Text>
  )
})

function PcListPanelHeaderBase({
  listPath,
  noticeCenter,
}: {
  listPath: PcTabPath
  noticeCenter?: boolean
}) {
  const theme = useTheme()
  const navigation = useNavigation()
  const navigate = useNavigate()

  if (noticeCenter) {
    return (
      <Header>
        <div style={{ minWidth: 72 }}>
          <IconButton
            name="left"
            size={36}
            iconSize={16}
            iconColor={theme.colors.text}
            onClick={() => navigate(getNoticeReturnPath(), { replace: true })}
          />
        </div>
        <Title>通知中心</Title>
        <div style={{ minWidth: 72, display: "flex", justifyContent: "flex-end" }}>
          <MarkAllReadButton />
        </div>
      </Header>
    )
  }

  const meta = TAB_META[listPath] || { title: "" }

  return (
    <Header>
      <div style={{ minWidth: 72 }}>
        {meta.showHomeHeader ? <LogoHeader /> : null}
      </div>
      <Title>{meta.showHomeHeader ? <HomeHeader /> : meta.title}</Title>
      <div style={{ minWidth: 72, display: "flex", justifyContent: "flex-end" }}>
        {meta.showHomeHeader ? <Dropdown /> : null}
        {listPath === "/contacts" ? (
          <IconButton
            name="tjhy"
            size={36}
            iconSize={16}
            iconColor={theme.colors.text}
            onClick={() => navigation.push("AddContact")}
          />
        ) : null}
      </div>
    </Header>
  )
}

export default observer(PcListPanelHeaderBase)
